import { render } from "./MyDashboardView.vue?vue&type=template&id=6d083bd7&scoped=true"
import script from "./MyDashboardView.vue?vue&type=script&lang=js"
export * from "./MyDashboardView.vue?vue&type=script&lang=js"

import "./MyDashboardView.vue?vue&type=style&index=0&id=6d083bd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d083bd7"]])

export default __exports__